import React, { FormEvent, useContext } from 'react'
import { UserLocationContext } from '../../contexts/user-location-context'
import { CheckBox } from '@at/design-system-elements'
import { FilterName } from '../../__generated__/fed-graphql-types'
import { useForm } from '../../forms/hocs/form.context'
import { getStoredPostcode } from '../../utils/search/local-search.util'
import { StyledSearchFilterLocationCheckboxContainer, StyledSearchFilterSelectLabel } from './location.styles'

export const Location = () => {
    const { isSelected } = useForm()
    const { location, updateLocation, updatePostcode } = useContext(UserLocationContext)
    const name = `${FilterName.location}-${location}`
    return (
        <StyledSearchFilterLocationCheckboxContainer as="section" key={name} data-testid="location-global-container">
            <CheckBox
                name={`location-global-checkbox`}
                id={`location-global-checkbox`}
                className={`location-global-checkbox`}
                label={<StyledSearchFilterSelectLabel as="span">{`I'm outside the UK`}</StyledSearchFilterSelectLabel>}
                data-testid="location-global-checkbox"
                onChange={(e: FormEvent<HTMLInputElement>) => {
                    const locationInput = (e?.currentTarget as HTMLInputElement)?.checked
                    if (locationInput) {
                        updateLocation('global')
                    } else {
                        updatePostcode(getStoredPostcode())
                    }
                }}
                checked={isSelected(FilterName.location)}
                reverse={true}
            />
        </StyledSearchFilterLocationCheckboxContainer>
    )
}
